import { render, staticRenderFns } from "./ques22.vue?vue&type=template&id=24984459&scoped=true"
import script from "./ques22.vue?vue&type=script&lang=js"
export * from "./ques22.vue?vue&type=script&lang=js"
import style0 from "./ques22.vue?vue&type=style&index=0&id=24984459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24984459",
  null
  
)

export default component.exports